document.addEventListener("DOMContentLoaded", function () {
  const navButtons = document.querySelectorAll(".shop-page-nav__button");

  navButtons.forEach((button) => {
    if (button.getAttribute("href") == window.location.pathname) {
      button.classList.add("active");
    }
    button.addEventListener("click", function (e) {
      e.preventDefault();
      setActiveBtn(e.target);

      if (button.getAttribute("href") == window.location.pathname) {
        button.classList.add("active");
      }

      let targetUrl = this.getAttribute("href") + "?view=ajax";

      fetch(targetUrl)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const pageDOM = parser.parseFromString(html, "text/html");
          const shopBanner = pageDOM.querySelector(".shop-banner");
          const productGrid = pageDOM.querySelector(".collection-products");

          document.querySelector(".shop-banner").innerHTML =
            shopBanner.innerHTML;
          document.querySelector(".collection-products").innerHTML =
            productGrid.innerHTML;

          if (e.target.innerText == "DELTA 8") {
            document.querySelector(".faq-section").style.display = "block";
          } else {
            document.querySelector(".faq-section").style.display = "none";
          }

          if (targetUrl.indexOf("best-sellers") !== -1) {
            document.querySelector(".shop-banner__img").style.left = "60%";
          }
        })
        .catch((error) => console.error("Error loading the page: ", error));
    });
  });

  function setActiveBtn(target) {
    navButtons.forEach((el) => el.classList.remove("active"));
    target.classList.add("active");
  }
});
